/**
 * Uma peça pré-montada, entregue de uma tela para a outra.
 *
 * O editor de carrossel gera N artes e abre a Nova peça com elas já na ordem
 * e no formato certos. A ordem é o que importa: no carrossel o primeiro item é
 * a capa e define a proporção dos outros, e remontar à mão — clicar nove
 * miniaturas na sequência certa — é exatamente onde a capa vira o slide 3.
 *
 * Em memória, e não na URL nem no `sessionStorage`: a navegação é por hash,
 * sem recarregar, então o módulo sobrevive à troca de tela. Recarregar a
 * página perde a entrega, e tudo bem — as artes já estão na biblioteca.
 *
 * Entregue a uma marca e consumida só por ela: se alguém trocar de marca no
 * topo entre gerar e abrir a Nova peça, a entrega é descartada em vez de pré
 * selecionar mídia de outra marca (que a API recusaria de qualquer jeito).
 */
export interface PecaPreMontada {
  brand: string;
  format: "IMAGE" | "CAROUSEL";
  mediaIds: number[];
}

let pendente: PecaPreMontada | null = null;

export function entregarPeca(p: PecaPreMontada): void {
  pendente = p;
}

/** Devolve a entrega UMA vez, e só para a marca a que ela pertence. */
export function receberPeca(brand: string): PecaPreMontada | null {
  const p = pendente;
  pendente = null;
  return p && p.brand === brand ? p : null;
}
